import React from "react"
import useSocialLinks from "../../hooks/useSocialLinks"
import Facebook from "../Icons/Facebook"
import Instagram from "../Icons/Instagram"
import Twitter from "../Icons/Twitter"
import { Link } from "../Link"
import Linkedin from "../Icons/Linkedin"

const SocialIcons: React.FC<{
  iconList?: string[]
  iconColor?: string
  ulStyling: any
  liStyling: any
}> = ({ ulStyling, liStyling, iconList = [], iconColor }) => {
  const socialLinks = useSocialLinks()
  const icons = {
    facebook: Facebook,
    twitter: Twitter,
    instagram: Instagram,
    linkedin: Linkedin,
  }

  // If linkedin isn't in the list, add instagram
  const finalIconList = iconList.includes("linkedin")
    ? iconList
    : ["facebook", "twitter", "instagram"]

  return (
    <ul css={[ulStyling]}>
      {socialLinks?.socials
        ?.filter(social => finalIconList.includes(social.name))
        .map(({ name, url }: { name: string; url: string }) => {
          const Icon: React.FC<{ iconColor?: string }> = icons[
            name as keyof typeof icons
          ] as React.FC<{ iconColor?: string }>

          return (
            <li key={name} css={[liStyling]}>
              <Link to={url}>
                <Icon iconColor={iconColor} />
              </Link>
            </li>
          )
        })}
    </ul>
  )
}

export default SocialIcons
